export enum DeployState {
    PENDING,
    STARTED,
    CANCELLED,
    SUCCESSFUL,
    DEPLOYED,
    FAILED
}

export namespace DeployStateExt {

    export function cantDeploy(state: string | undefined): boolean {
        return state != undefined && (state === DeployState[DeployState.STARTED] || state === DeployState[DeployState.DEPLOYED] || state === DeployState[DeployState.FAILED]);
    }

    export function fromString(state: string): DeployState {
        return DeployState[state as keyof typeof DeployState] as DeployState
    }

    export function getDeployStateText(state: DeployState): string {
        switch (state) {
            case DeployState.PENDING:
                return "待部署";
            case DeployState.STARTED:
                return "部署中";
            case DeployState.CANCELLED:
                return "已取消";
            case DeployState.SUCCESSFUL:
                return "部署成功";
            case DeployState.FAILED:
                return "部署失败";
            case DeployState.DEPLOYED:
                return "已部署";
            default:
                return "未知";
        }
    }

    export function getPackageStateText(state: DeployState): string {
        switch (state) {
            case DeployState.PENDING:
                return "待构建";
            case DeployState.STARTED:
                return "构建中";
            case DeployState.CANCELLED:
                return "已取消";
            case DeployState.SUCCESSFUL:
                return "构建成功";
            case DeployState.FAILED:
                return "构建失败";
            default:
                return "未知";
        }
    }

    export function getRollbackStateText(state: DeployState): string {
        switch (state) {
            case DeployState.PENDING:
                return "待回滚";
            case DeployState.STARTED:
                return "回滚中";
            case DeployState.CANCELLED:
                return "已取消";
            case DeployState.SUCCESSFUL:
                return "回滚成功";
            case DeployState.FAILED:
                return "回滚失败";
            case DeployState.DEPLOYED:
                return "已回滚";
            default:
                return "未知";
        }
    }

    export function getDeployStateTextFromString(state: string): string {
        return getDeployStateText(fromString(state));
    }

    export function getPackageStateTextFromString(state: string): string {
        return getPackageStateText(fromString(state));
    }

    export function getRollbackStateTextFromString(state: string): string {
        return getRollbackStateText(fromString(state));
    }

    export function getStatusColor(state: DeployState): string {
        switch (state) {
            case DeployState.STARTED:
                return '#1890ff';
            case DeployState.SUCCESSFUL:
                return '#52c41a';
            case DeployState.FAILED:
                return '#f5222d';
            default:
                return '#4e4e4e';
        }
    }

    export function getStatusColorFromString(state: string): string {
        return getStatusColor(fromString(state));
    }
}